const { useRef, useEffect, useCallback } = require('react');

const useEventCallback = (func = () => null, depend = []) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = func;
    // eslint-disable-next-line
  }, [...depend]);

  return useCallback((...params) => {
    return ref.current && ref.current(...params);
    // eslint-disable-next-line
  }, []);
};

export default useEventCallback;
